<template lang="pug" src="./custom-adults-block.pug"></template>

<script>
export default {
  data () {
    return {
      showTitle: false
    }
  },
  props: ['props'],
  methods: {
    onWaypoint ({ going, direction }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.showTitle = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-adults-block/custom-adults-block.vue